import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'

import { ChooseShare } from './ChooseShare'
import ShareApi from '../../../api/ShareApi'
import { normalizedName } from '../../../components/entities/CompanyName'

import { ShareEntity } from 'types/ShareEntity'
import { CompanyEntity } from 'types/CompanyEntity'
import { ConvertibleInput } from '../../../api/ConvertiblesApi'

const shareApi = new ShareApi()

type NewConvertibleQuickFormProps = {
    company: Pick<CompanyEntity, 'id' | 'name'>
    open: boolean
    setOpen: (open: boolean) => void
    handleCreateConvertible: (share: ShareEntity, formData: Omit<ConvertibleInput, 'shareId'>) => Promise<void>
}

export const NewConvertibleQuickForm = ({
    company,
    open,
    setOpen,
    handleCreateConvertible,
}: NewConvertibleQuickFormProps) => {
    const [shares, setShares] = useState<ShareEntity[] | null>(null)
    const [share, setShare] = useState<ShareEntity | null>(null)
    const [submitting, setSubmitting] = useState(false)
    const formMethods = useForm()

    useEffect(() => {
        const fetchData = async () => {
            if (!company) return
            const result = await shareApi.findByCompanyId(company.id)
            setShares(result)
        }
        void fetchData()
    }, [company])

    const handleClose = () => {
        setShare(null)
        formMethods.reset()
        setSubmitting(false)
        setOpen(false)
    }

    if (!company) return null

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
                component: 'form',
                onSubmit: async (event: SubmitEvent) => {
                    event.preventDefault()
                    if (submitting) return
                    setSubmitting(true)
                    const formData = formMethods.getValues()
                    console.log(JSON.stringify(formData, null, 2))
                    await handleCreateConvertible(share, formData)
                    handleClose()
                    setSubmitting(false)
                },
            }}
        >
            <DialogTitle>Ny konvertibel för {normalizedName(company.name)}</DialogTitle>
            <DialogContent>
                <FormProvider {...formMethods}>
                    <Stack spacing={2} py={2}>
                        <ChooseShare shares={shares} share={share} setShare={setShare} />
                    </Stack>
                </FormProvider>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Avbryt</Button>
                <Button type='submit'>Skapa {submitting && <CircularProgress />}</Button>
            </DialogActions>
        </Dialog>
    )
}
